module.exports = __webpack_public_path__ + "img/Tail_feathers_Normal.35dce44.png";